/* tslint:disable */
/* eslint-disable */
/**
 * PopshopLive API
 * PopshopLive API service
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import {
    AssignBadgeRequest,
    AuditBadgeRequest,
    BatchAssignBadgeRequest,
    BatchAssignBadgeResponse,
    CreateBadgeRequest,
    IdResponse,
    PatchBadgeRequest,
} from '../models';

export interface StoreBadgeApiControllerAssignBadgeRequest {
    badgeId: string;
    userId: string;
    assignBadgeRequest: AssignBadgeRequest;
}

export interface StoreBadgeApiControllerAuditBadgeRequest {
    storeId: string;
    badgeId: string;
    auditBadgeRequest: AuditBadgeRequest;
}

export interface StoreBadgeApiControllerBatchAssignBadgeRequest {
    batchAssignBadgeRequest: BatchAssignBadgeRequest;
}

export interface StoreBadgeApiControllerCreateBadgeRequest {
    storeId: string;
    createBadgeRequest: CreateBadgeRequest;
}

export interface StoreBadgeApiControllerDeleteStoreBadgeRequest {
    storeId: string;
    badgeId: string;
}

export interface StoreBadgeApiControllerPatchBadgeRequest {
    storeId: string;
    badgeId: string;
    patchBadgeRequest: PatchBadgeRequest;
}

export interface StoreBadgeApiControllerRevokeBadgeRequest {
    badgeId: string;
    userId: string;
}

export interface StoreBadgeApiControllerSubmitBadgeRequest {
    storeId: string;
    badgeId: string;
}

/**
 * 
 */
export class StoreBadgeApi extends runtime.BaseAPI {

    /**
     */
    async storeBadgeApiControllerAssignBadgeRaw(requestParameters: StoreBadgeApiControllerAssignBadgeRequest): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.badgeId === null || requestParameters.badgeId === undefined) {
            throw new runtime.RequiredError('badgeId','Required parameter requestParameters.badgeId was null or undefined when calling storeBadgeApiControllerAssignBadge.');
        }

        if (requestParameters.userId === null || requestParameters.userId === undefined) {
            throw new runtime.RequiredError('userId','Required parameter requestParameters.userId was null or undefined when calling storeBadgeApiControllerAssignBadge.');
        }

        if (requestParameters.assignBadgeRequest === null || requestParameters.assignBadgeRequest === undefined) {
            throw new runtime.RequiredError('assignBadgeRequest','Required parameter requestParameters.assignBadgeRequest was null or undefined when calling storeBadgeApiControllerAssignBadge.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/users/{userId}/badges/{badgeId}`.replace(`{${"badgeId"}}`, encodeURIComponent(String(requestParameters.badgeId))).replace(`{${"userId"}}`, encodeURIComponent(String(requestParameters.userId))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.assignBadgeRequest,
        });

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async storeBadgeApiControllerAssignBadge(requestParameters: StoreBadgeApiControllerAssignBadgeRequest): Promise<void> {
        await this.storeBadgeApiControllerAssignBadgeRaw(requestParameters);
    }

    /**
     */
    async storeBadgeApiControllerAuditBadgeRaw(requestParameters: StoreBadgeApiControllerAuditBadgeRequest): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.storeId === null || requestParameters.storeId === undefined) {
            throw new runtime.RequiredError('storeId','Required parameter requestParameters.storeId was null or undefined when calling storeBadgeApiControllerAuditBadge.');
        }

        if (requestParameters.badgeId === null || requestParameters.badgeId === undefined) {
            throw new runtime.RequiredError('badgeId','Required parameter requestParameters.badgeId was null or undefined when calling storeBadgeApiControllerAuditBadge.');
        }

        if (requestParameters.auditBadgeRequest === null || requestParameters.auditBadgeRequest === undefined) {
            throw new runtime.RequiredError('auditBadgeRequest','Required parameter requestParameters.auditBadgeRequest was null or undefined when calling storeBadgeApiControllerAuditBadge.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/stores/{storeId}/badges/{badgeId}:audit`.replace(`{${"storeId"}}`, encodeURIComponent(String(requestParameters.storeId))).replace(`{${"badgeId"}}`, encodeURIComponent(String(requestParameters.badgeId))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.auditBadgeRequest,
        });

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async storeBadgeApiControllerAuditBadge(requestParameters: StoreBadgeApiControllerAuditBadgeRequest): Promise<void> {
        await this.storeBadgeApiControllerAuditBadgeRaw(requestParameters);
    }

    /**
     */
    async storeBadgeApiControllerBatchAssignBadgeRaw(requestParameters: StoreBadgeApiControllerBatchAssignBadgeRequest): Promise<runtime.ApiResponse<BatchAssignBadgeResponse>> {
        if (requestParameters.batchAssignBadgeRequest === null || requestParameters.batchAssignBadgeRequest === undefined) {
            throw new runtime.RequiredError('batchAssignBadgeRequest','Required parameter requestParameters.batchAssignBadgeRequest was null or undefined when calling storeBadgeApiControllerBatchAssignBadge.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/badges:batchAssign`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.batchAssignBadgeRequest,
        });

        return new runtime.JSONApiResponse(response);
    }

    /**
     */
    async storeBadgeApiControllerBatchAssignBadge(requestParameters: StoreBadgeApiControllerBatchAssignBadgeRequest): Promise<BatchAssignBadgeResponse> {
        const response = await this.storeBadgeApiControllerBatchAssignBadgeRaw(requestParameters);
        return await response.value();
    }

    /**
     */
    async storeBadgeApiControllerCreateBadgeRaw(requestParameters: StoreBadgeApiControllerCreateBadgeRequest): Promise<runtime.ApiResponse<IdResponse>> {
        if (requestParameters.storeId === null || requestParameters.storeId === undefined) {
            throw new runtime.RequiredError('storeId','Required parameter requestParameters.storeId was null or undefined when calling storeBadgeApiControllerCreateBadge.');
        }

        if (requestParameters.createBadgeRequest === null || requestParameters.createBadgeRequest === undefined) {
            throw new runtime.RequiredError('createBadgeRequest','Required parameter requestParameters.createBadgeRequest was null or undefined when calling storeBadgeApiControllerCreateBadge.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/stores/{storeId}/badges`.replace(`{${"storeId"}}`, encodeURIComponent(String(requestParameters.storeId))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.createBadgeRequest,
        });

        return new runtime.JSONApiResponse(response);
    }

    /**
     */
    async storeBadgeApiControllerCreateBadge(requestParameters: StoreBadgeApiControllerCreateBadgeRequest): Promise<IdResponse> {
        const response = await this.storeBadgeApiControllerCreateBadgeRaw(requestParameters);
        return await response.value();
    }

    /**
     */
    async storeBadgeApiControllerDeleteStoreBadgeRaw(requestParameters: StoreBadgeApiControllerDeleteStoreBadgeRequest): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.storeId === null || requestParameters.storeId === undefined) {
            throw new runtime.RequiredError('storeId','Required parameter requestParameters.storeId was null or undefined when calling storeBadgeApiControllerDeleteStoreBadge.');
        }

        if (requestParameters.badgeId === null || requestParameters.badgeId === undefined) {
            throw new runtime.RequiredError('badgeId','Required parameter requestParameters.badgeId was null or undefined when calling storeBadgeApiControllerDeleteStoreBadge.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/stores/{storeId}/badges/{badgeId}`.replace(`{${"storeId"}}`, encodeURIComponent(String(requestParameters.storeId))).replace(`{${"badgeId"}}`, encodeURIComponent(String(requestParameters.badgeId))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async storeBadgeApiControllerDeleteStoreBadge(requestParameters: StoreBadgeApiControllerDeleteStoreBadgeRequest): Promise<void> {
        await this.storeBadgeApiControllerDeleteStoreBadgeRaw(requestParameters);
    }

    /**
     */
    async storeBadgeApiControllerPatchBadgeRaw(requestParameters: StoreBadgeApiControllerPatchBadgeRequest): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.storeId === null || requestParameters.storeId === undefined) {
            throw new runtime.RequiredError('storeId','Required parameter requestParameters.storeId was null or undefined when calling storeBadgeApiControllerPatchBadge.');
        }

        if (requestParameters.badgeId === null || requestParameters.badgeId === undefined) {
            throw new runtime.RequiredError('badgeId','Required parameter requestParameters.badgeId was null or undefined when calling storeBadgeApiControllerPatchBadge.');
        }

        if (requestParameters.patchBadgeRequest === null || requestParameters.patchBadgeRequest === undefined) {
            throw new runtime.RequiredError('patchBadgeRequest','Required parameter requestParameters.patchBadgeRequest was null or undefined when calling storeBadgeApiControllerPatchBadge.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/stores/{storeId}/badges/{badgeId}`.replace(`{${"storeId"}}`, encodeURIComponent(String(requestParameters.storeId))).replace(`{${"badgeId"}}`, encodeURIComponent(String(requestParameters.badgeId))),
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.patchBadgeRequest,
        });

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async storeBadgeApiControllerPatchBadge(requestParameters: StoreBadgeApiControllerPatchBadgeRequest): Promise<void> {
        await this.storeBadgeApiControllerPatchBadgeRaw(requestParameters);
    }

    /**
     */
    async storeBadgeApiControllerRevokeBadgeRaw(requestParameters: StoreBadgeApiControllerRevokeBadgeRequest): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.badgeId === null || requestParameters.badgeId === undefined) {
            throw new runtime.RequiredError('badgeId','Required parameter requestParameters.badgeId was null or undefined when calling storeBadgeApiControllerRevokeBadge.');
        }

        if (requestParameters.userId === null || requestParameters.userId === undefined) {
            throw new runtime.RequiredError('userId','Required parameter requestParameters.userId was null or undefined when calling storeBadgeApiControllerRevokeBadge.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/users/{userId}/badges/{badgeId}`.replace(`{${"badgeId"}}`, encodeURIComponent(String(requestParameters.badgeId))).replace(`{${"userId"}}`, encodeURIComponent(String(requestParameters.userId))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async storeBadgeApiControllerRevokeBadge(requestParameters: StoreBadgeApiControllerRevokeBadgeRequest): Promise<void> {
        await this.storeBadgeApiControllerRevokeBadgeRaw(requestParameters);
    }

    /**
     */
    async storeBadgeApiControllerSubmitBadgeRaw(requestParameters: StoreBadgeApiControllerSubmitBadgeRequest): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.storeId === null || requestParameters.storeId === undefined) {
            throw new runtime.RequiredError('storeId','Required parameter requestParameters.storeId was null or undefined when calling storeBadgeApiControllerSubmitBadge.');
        }

        if (requestParameters.badgeId === null || requestParameters.badgeId === undefined) {
            throw new runtime.RequiredError('badgeId','Required parameter requestParameters.badgeId was null or undefined when calling storeBadgeApiControllerSubmitBadge.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/stores/{storeId}/badges/{badgeId}:submit`.replace(`{${"storeId"}}`, encodeURIComponent(String(requestParameters.storeId))).replace(`{${"badgeId"}}`, encodeURIComponent(String(requestParameters.badgeId))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async storeBadgeApiControllerSubmitBadge(requestParameters: StoreBadgeApiControllerSubmitBadgeRequest): Promise<void> {
        await this.storeBadgeApiControllerSubmitBadgeRaw(requestParameters);
    }

}
